import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      create: false,
      plugins: {
        checkbox_options: {
          checkedClassNames: ["ts-checked"],
          uncheckedClassNames: ["ts-unchecked"]
        }
      },
      onChange: () => {
        if (this.element.getAttribute("multiple") === "multiple") return;

        this.tomSelect.close();
        this.tomSelect.blur();
      }
    });
  }
}
